export const KEY_CONTACT_POSITION = 'Key Contact';
